import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { AuthDetailsService } from '../../../common/auth-details/auth-details.service';

@Injectable({
	providedIn: 'root'
})
export class EditSpecializationService extends iBisSecureEditService {
	public data: CustomStore;
	public calendarData: any;

	constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private ad: AuthDetailsService) {
		super(auth, entity, config, lg);
		this.title = 'SPECIALIZATION';
		this.validation = 'SpecializationValidation';
		this.ad.onDataChanged.subscribe(_ => {
			this.load();
		})
	}
	protected load(): void {
		this.data = this.getData();
		this.ad.partyUserDataLoadedSubject.subscribe(_ => {
			this.getCalendarData()
		})
	}
	createDefault() {
		return { isActiv: true };
	}
	getById(id: string): Promise<any> {
		return new Promise((resolve, reject) => {
			this.entity.getById('Specialization', id).then((obj) => {
				if (obj) {
					resolve(obj);
				} else {
					reject();
				}
			}, error => this.lg.showError(error));
		});
	}
	onRemove(id: string): Promise<void> {
		return this.entity.remove('Specialization', id);
	}
	onSaveEv(serverUrl?: string): Promise<any> {
		//return this.entity.save('Specialization', this.model.id, this.model);
		this.model.typeId = '460dadc9-5529-436e-9781-f504f3964e38'
		return this.entity.save('EnumValue', this.model.id, this.model);
	}
	reset(): void {
		this.model = this.createDefault();
	}
	private getData(): CustomStore {
		const q = new EntityQuery('EnumValue').linkEq('typeId', 'id', 'EnumType', 'code', 'SPC').addOrderBy(['code']);
		//TODO: remove this code when Specialization is added
		//return this.entity.store(new EntityQuery('Specialization').addOrderBy(['code']));
		return this.entity.store(q)
	}

	private async getCalendarData() {
		//TODO: remove this code when Specialization is added

		/* const q = new EntityQuery('UserLogin').eq('isActiv', true)
		q.link('id', 'userId', new EntityQuery('ApplicationRole').eq('appId', this.auth.companyId));
		const users = await this.entity.load(q, this.config.saasServer)
		const sq = new EntityQuery('Specialization', false, true).addOrderBy(['code']);
		sq.link('id', 'specializationId', new EntityQuery('UserSpecialization').in('userId', users.map(user => user.id)).eq('partyId', this.ad.authDetails.party.id));
		this.entity.store(sq).load().then(specs => this.calendarData = specs); */

		const q = new EntityQuery('EnumValue').linkEq('typeId', 'id', 'EnumType', 'code', 'SPC');
		const qps = new EntityQuery('PartySpecialization').eq('partyId', this.ad.authDetails.party.id);
		const qus = new EntityQuery('UserSpecialization').eq('partyId', this.ad.authDetails.party.id);
		//q.link('id', 'specializationId', qps);
		q.link('id', 'specializationId', qus);
		q.distinct = true;
		return this.entity.load(q).then((specs: any[]) => {
			this.calendarData = specs;
		});
	}
}
